<template>
  <ModalMiddle :title="t('setting')" :is-blurred="false" @close="onClickCancel">
    <AuxiliaryDisplayControlScreen v-model="screenPreference" type="local" />
  </ModalMiddle>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import AuxiliaryDisplayControlScreen from '@/components/domains/chat/chat-general/AuxiliaryDisplayControlScreen.vue';
import ModalMiddle from '@/components/shared/composite/ModalMiddle.vue';
import { useChatPreferenceStore } from '@/stores/chatPreference';

const emit = defineEmits(['close']);

const { t } = useI18n();

const chatPreferenceStore = useChatPreferenceStore();
const { screenPreference } = storeToRefs(chatPreferenceStore);

const onClickCancel = () => {
  emit('close');
};
</script>

<style scoped lang="scss">
.wrapper-buttons {
  width: 100%;
  margin-top: 1rem;
}

.dropdown-trigger {
  display: flex;
  width: 100%;
  gap: 0.5rem;
  justify-content: center;
  padding: 0.75rem;
  background-color: var(--surface-default);
  border-radius: 8px;
  cursor: pointer;
}

.dropdown-trigger:hover,
.dropdown-trigger:active,
.dropdown-trigger.active {
  background-color: var(--surface-gray-dim);
}

::v-deep(.dropdown-content) {
  width: 77dvw;
  max-width: 21rem;
}

.language-container {
  width: 100%;
  position: relative;
}

.language-options {
  position: absolute;
  width: 100%;
  z-index: 999;
  max-height: 300px;
  overflow-y: auto;
}
</style>
